import { type PropsWithChildren, type ReactElement } from "react";
import { EnableAnimationsContext } from "./EnableAnimationsProvider.context";

type EnableAnimationsProviderProps = {
  value?: boolean;
};

/**
 * The EnableAnimationsProvider component provides a context for holding off animations until a certain point,
 * which is usefull for first preloading and than starting animations.
 *
 * @example
 * // In RootClientLayout.tsx
 * <LocaleProvider resource={resource} locale={locale}>
 *   <EnableAnimationsProvider value={isPreloaded}>{children}</EnableAnimationsProvider>
 * </LocaleProvider>
 */
export function EnableAnimationsProvider({
  value = true,
  children,
}: PropsWithChildren<EnableAnimationsProviderProps>): ReactElement {
  return (
    <EnableAnimationsContext.Provider value={value}>
      {children}
    </EnableAnimationsContext.Provider>
  );
}
